import { render, staticRenderFns } from "./AcompanhamentoEdit.vue?vue&type=template&id=6c5217ab&scoped=true&"
import script from "./AcompanhamentoEdit.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoEdit.vue?vue&type=script&lang=js&"
import style0 from "./AcompanhamentoEdit.vue?vue&type=style&index=0&id=6c5217ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5217ab",
  null
  
)

export default component.exports